import React,{useState, useEffect} from 'react';
import { Alert, AlertTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export default function BrowserNotice() {
   const [enableBrowserWarning, setBrowserWarning] = useState(false);
   const [open, setOpen] = useState(false);

   const userAgent = navigator.userAgent;
   let browserName = "";
   
   if(userAgent.match(/chrome|chromium|crios/i)){
      browserName = "chrome";
   }else if(userAgent.match(/firefox|fxios/i)){
      browserName = "firefox";
   }  else if(userAgent.match(/safari/i)){
      browserName = "safari";
   }else if(userAgent.match(/opr\//i)){
      browserName = "opera";
   } else if(userAgent.match(/edg/i)){
      browserName = "edge";
   }else{
      browserName="No browser detection";
   }
   
   useEffect(() => {
      if ( browserName == 'firefox' || browserName == 'safari' ) {
         setBrowserWarning(false)
      }else {
         setBrowserWarning(true)
      }

      if ( localStorage.getItem('welcome_notice') != '1') {
         setOpen(true)
      }else {
         setOpen(false)
      }
      return () => {
         console.log('DisMounting Welcome Popup')
      }
    }, [])
    return (
        <>
        { (enableBrowserWarning && open) &&
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon
                  fontSize="inherit" 
                  onClick={() => {
                      console.log('Closing')
                      setOpen(false);
                  }} />
            </IconButton>
          }
          severity='warning'
          sx={{ mb: 2 }}
        >
            <AlertTitle>Browser Notice</AlertTitle>
            <p>{browserName} browser detected, we recommend the use of the Firefox and Safari browsers. Streaming may fail on Chrome.</p>
        </Alert>
        }
        </>
    );
};
